import React from 'react'
import BookList from './BookList'
export default function Books() {
    return (
        <>
            <BookList />
        </>
    )
}
